/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const renameProductVendor = createAsyncThunk(
  'productVendors/rename',
  async ({ productVendorId, title, originalTitle }, {
    extra: {
      sdk, utils, localization, Toast, Logger, showDialogAsync,
    },
  }) => {
    const trimmedTitle = title.trim();
    const {
      TITLE, TEXT, OK, CANCEL,
    } = localization.DIALOGS.PRODUCT_VENDOR_RENAME;

    try {
      const { promise } = showDialogAsync({
        title: TITLE(originalTitle, trimmedTitle),
        text: TEXT,
        textBtnCancel: CANCEL,
        textBtnOk: OK,
      });
      await promise;
    } catch (error) {
      /** user pressed "Cancel" */
      return { cancelled: true };
    }

    try {
      const { data } = await sdk.productVendors.update(productVendorId, { title: trimmedTitle });
      return { productVendor: data };
    } catch (error) {
      const subcode = utils.getDataFromResponceError(error, 'subcode');
      if (subcode === 'ProductVendorAlreadyExistsApiError') {
        Toast(localization.PRODUCT_VENDORS.alreadyExists, { autoClose: 5000, type: 'error' });
        return null; /** no need to throw the error */
      }
      Logger.error(new Error('Can not rename product vendor'), { error }, [
        'RenameProductVendorFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(renameProductVendor.pending, (state, { meta }) => {
      const { productVendorId } = meta.arg;
      if (!state.processingIds.includes(productVendorId)) {
        state.processingIds.push(productVendorId);
      }
    })
    .addCase(renameProductVendor.fulfilled, (state, { payload, meta }) => {
      state.processingIds = state.processingIds.filter(
        (processingId) => processingId !== meta.arg.productVendorId,
      );
      if (!payload || payload.cancelled) return;
      const item = state.items.find(({ _id }) => _id === payload.productVendor._id);
      if (item) {
        item.title = payload.productVendor.title;
      }
    })
    .addCase(renameProductVendor.rejected, (state, { error, meta }) => {
      state.processingIds = state.processingIds.filter(
        (processingId) => processingId !== meta.arg.productVendorId,
      );
      state.error = error;
    });
};
